<script setup>
import { useRoute } from 'vue-router';
import ConversationSkeleton from 'dashboard/components/widgets/conversation/ConversationSkeleton.vue';
import ConversationListSkeleton from 'dashboard/components/widgets/conversation/ConversationListSkeleton.vue';
import PageLoadingBar from 'dashboard/components-next/loading/PageLoadingBar.vue';

const route = useRoute();
</script>

<template>
  <div
    class="fixed inset-0 flex h-[100dvh] flex-col overflow-hidden bg-n-surface-1"
  >
    <ConversationSkeleton
      v-if="route.params.conversationId || route.params.conversation_id"
      :loading-message="$t('CONVERSATION.LOADING_CONVERSATIONS')"
    >
      <template #header-loading><PageLoadingBar /></template>
    </ConversationSkeleton>
    <template v-else>
      <div
        class="flex h-14 shrink-0 items-center justify-between border-b border-n-weak px-4 motion-safe:animate-pulse"
        aria-hidden="true"
      >
        <div class="h-4 w-24 rounded bg-n-alpha-2" />
        <div class="size-6 rounded bg-n-alpha-2" />
      </div>
      <PageLoadingBar />
      <ConversationListSkeleton class="min-h-0 flex-1 overflow-hidden" />
    </template>
  </div>
</template>
